import { render, staticRenderFns } from "./Tabella.vue?vue&type=template&id=6c5e8f79&scoped=true"
import script from "./Tabella.vue?vue&type=script&lang=js"
export * from "./Tabella.vue?vue&type=script&lang=js"
import style0 from "./Tabella.vue?vue&type=style&index=0&id=6c5e8f79&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c5e8f79",
  null
  
)

export default component.exports